import { motion } from "framer-motion";

const Footer = () => {
  return (
    <footer className="relative isolate bg-gradient-to-b from-white via-slate-50 to-slate-100 border-t border-slate-200/60">
      {/* Subtle background pattern */}
      <div aria-hidden className="absolute inset-0 pattern-dots opacity-[0.02]" />
      
      <div className="relative mx-auto max-w-7xl px-4 sm:px-6 lg:px-8 py-8">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.5, ease: [0.16, 0.66, 0.45, 0.99] }}
          className="text-center"
        >
          {/* Privacy notice with icon */}
          <div className="inline-flex items-start gap-3 max-w-3xl mx-auto">
            <div className="flex-shrink-0 mt-0.5">
              <svg 
                className="w-5 h-5 text-emerald-600/70" 
                fill="none" 
                stroke="currentColor" 
                viewBox="0 0 24 24"
                aria-hidden="true"
              >
                <path 
                  strokeLinecap="round" 
                  strokeLinejoin="round" 
                  strokeWidth={2} 
                  d="M12 15v2m-6 4h12a2 2 0 002-2v-6a2 2 0 00-2-2H6a2 2 0 00-2 2v6a2 2 0 002 2zm10-10V7a4 4 0 00-8 0v4h8z" 
                />
              </svg>
            </div>
            <p className="text-sm text-gray-600 leading-relaxed text-left">
              <span className="font-semibold text-gray-700">Privacy Notice:</span>{" "}
              This site does not use cookies for tracking or analytics. A small local storage entry may be used to remember interface settings (e.g., accepting terms), but no personal data is stored.
            </p>
          </div>
          
          {/* Optional: Copyright/Credits line */}
          <div className="mt-6 pt-6 border-t border-slate-200/60">
            <p className="text-xs text-gray-500">
              © {new Date().getFullYear()} All rights reserved.
            </p>
          </div>
        </motion.div>
      </div>
    </footer>
  );
};

export default Footer;
